/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable func-names */
/* eslint-disable no-console */

'use client'

import { useEffect } from 'react'
import logger from '@utils/logger'
import { loadGtmScript } from './loadGtmScript'

// Keep the existing delayed load; cancel an obsolete mount so navigation cannot inject duplicate containers.
const InjectGTM = ({ GTM_ID }) => {
  useEffect(() => {
    const timeout = window.setTimeout(() => {
      loadGtmScript(GTM_ID)
        .then(() => logger.info('GTM Script Loaded Successfully'))
        .catch(err => logger.info('GTM Script Error:', err))
    }, 500)
    return () => window.clearTimeout(timeout)
  }, [GTM_ID])

  return null
}

export default InjectGTM
